<template>
    <div class="tab-pane fade show active" id="pricing" role="tabpanel" aria-labelledby="pricing-tab">
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="row">
                <div class="col-md-6 clearfix">
                    <h3 class="pt-2 mb-2">Product Bundles</h3>
                </div>
                <div class="col-md-6 text-right">
                    <button class="btn btn-primary text-right mb-2" data-toggle="collapse" data-target="#add_product_bundle">Add Product To Bundle</button>
                </div>
            </div>
            <div id="add_product_bundle" class="collapse border p-4 mb-1">
                <div class="form-group">
                    <label for="">Product</label>
                    <select-item-from-api-provided-list
                        class="pt-2"
                        api="pimapi/products"
                        :columns="['name']"
                        list-label="Select Product"
                        @selection="selectRelationProduct"
                        apiType="meta"
                        :small="true"
                    />
                </div>
                <div class="form-group text-right">
                    <a v-on:click.prevent="postProductBundle" href="#" class="btn btn-primary">Save</a>
                </div>
            </div>
            <div class="dataTables_wrapper container-fluid dt-bootstrap4 mt-2">
                <vuetable ref="vuetable"
                        :api-url="grid"
                        :fields="fields"
                        :css="css.table"
                        noDataTemplate="No Product Bundles Found"
                        @vuetable:loaded="onLoaded"
                        pagination-data=""
                        pagination-path=""
                        data-path="bundles"
                    >
                    <template slot="options" slot-scope="props">
                        <div class="text-right">
                            <button type="button" class="btn btn-outline-primary" @click="deleteBundle(props.rowData.id)">
                                <i class="fa fa-trash" aria-hidden="true"></i>
                            </button>
                        </div>
                    </template>
                </vuetable>
            </div>
            <transition name="vue-table-loader">
                <div class="messaging" v-if="message">{{message}}</div>
            </transition>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host

import Vue from 'vue';
import VueEvents from 'vue-events'
import axios from 'axios'
import _ from "lodash";
import moment from 'moment';
import * as Vuetable from 'vuetable-2';
import BasePagination from '../tables/base-pagination.vue';
import BasePaginationInfo from '../tables/base-pagination-info.vue';
import select2 from 'select2';
import SelectItemFromApiProvidedList from "../generic/select-item-from-api-provided-list.vue";

Vue.use(VueEvents)

export default {
    name: 'product-details-bundles',
    components: {
        "select-item-from-api-provided-list": SelectItemFromApiProvidedList,
    },
    data() {
        return {
            perPage: 10,
            loading: true,
	    	moreParams: {},
            message: "",
            uiStates: {
                addProductRelation: false,
                showLoading: false,
                showCloneProduct: false,
            },
            ProductListing: {
                products: [],
                relationTypes: [],
                selected: {
                    type: null,
                    product: null,
                },
            },
            grid: base_url + '/pimapi/products/' + this.$parent.product.info.id + '/bundles',
            fields: [
                {
                    name: 'parent',
                    title: 'Parent'
                },
                {
                    name: 'sku',
                    title: 'SKU',
                },
                {
                    name: 'saleable',
                    title: 'Saleable',
                },
                {
                   name: '__slot:options'                           ,
                   title: ''
                }
            ],
            css: {
                table: {
                    tableClass: 'table table-middle table-minimal',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    infoClass: '',
                },
            },
        }
    },
    methods: {
        selectRelationProduct(product) {
            this.ProductListing.selected.product = product;
        },
        postProductBundle() {
            this.loading = true;
            axios.post(base_url+ '/pimapi/products/'+ this.$parent.product.info.id + '/bundles/' + this.ProductListing.selected.product.id)
                .then(function (response) {
                    this.loading = false;
                    this.collapseForm();
                    this.$refs.vuetable.reload();
                    this.$parent.alert.message = 'A new bundle has been added';
                    this.$parent.alert.status = 'alert-success';
                }.bind(this))
                .catch(function (error) {
                    this.$parent.alert.status = 'alert-danger';
                    this.$parent.alert.message = error.response.data.message;
                }.bind(this));
        },
        deleteBundle(id) {
            this.uiStates.showLoading = true;
            axios.delete(base_url + '/pimapi/products/' + this.$parent.product.info.id + '/bundles/' + id)
                .then(function(response) {
                    this.uiStates.showLoading = false;
                    this.$refs.vuetable.reload();
                    this.$parent.alert.message = 'Bundle (id:' + id + ') has been removed';
                    this.$parent.alert.status = 'alert-success';
                }.bind(this))
                .catch(function(error) {
                    this.$parent.alert.status = 'alert-danger';
                    this.$parent.alert.message = error.response.data.message;
                    console.log(error);
                }.bind(this));
        },
        onLoaded: function() {
            this.loading = false;
        },
        collapseForm: function() {
            $('#add_product_bundle').collapse('toggle');
        }
    },
    watch: {
        message: function(query) {
            setTimeout(function() {
                this.message = "";
            }.bind(this), 3000);
        }
    }
}
</script>

<style>

</style>
